export enum SystemLanguages {
  EN = 'en'
}

export const defaultSystemLanguage = SystemLanguages.EN

export enum CookiesLocations {
  LOCALE = 'locale',
}

export enum ProjectType {
  RESIDENTIAL = 'residential',
  MIXED = 'mixed',
  COMMERCIAL = 'commercial',
  INDUSTRIAL = 'industrial'
}

export enum ProjectStatus {
  PLANNING = 'planning',
  COMPLETED = 'completed',
  UNDER_CONSTRUCTION = 'under_construction'
}

export enum FloorPlanType {
  APARTMENT = 'apartment',
  VILLA = 'villa',
  TOWNHOUSE = 'townhouse'
}

export enum TransportMode {
  walking = 'walking',
  driving = 'driving',
  'public-transport' = 'publicTransport',
  cycling = 'cycling'
}

export enum LocationCategory {
  ENTERTAINMENT = 'entertainment',
  CLINIC = 'clinic',
  SCHOOL = 'school',
  SHOPPING = 'shopping',
  RESTAURANT = 'restaurant',
  TRANSPORT = 'transport',
  OTHER = 'other'
}